import MLabeledContainer from "./MLabeledContainer.vue";
export default MLabeledContainer;
